module.exports = new __parcel__URL__("bossfight_go_to_discord_button.40a0438b.png").toString();